import React from 'react';
import styled from 'styled-components';

const Badge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  ${(props) => {
    switch (props.variant) {
      case 'cancelled':
        return `
          background-color: #fee2e2;
          color: #dc2626;
        `;
      case 'refunded':
        return `
          background-color: #ffedd5;
          color: #ea580c;
        `;
      case 'partial_refund':
        return `
          background-color: #fef3c7;
          color: #d97706;
        `;
      case 'completed':
      default:
        return `
          background-color: #dcfce7;
          color: #16a34a;
        `;
    }
  }}
`;

const OrderStatusBadge = ({ isCancelled, totalRefunded, grandTotal }) => {
  if (isCancelled) {
    return <Badge variant="cancelled">Cancelled</Badge>;
  }

  if (totalRefunded > 0) {
    if (totalRefunded >= grandTotal) {
      return <Badge variant="refunded">Refunded</Badge>;
    }
    return <Badge variant="partial_refund">Partial Refund</Badge>;
  }

  return null; // Don't show badge for normal completed orders
};

export default OrderStatusBadge;
